module.exports = __webpack_public_path__ + "static/22-36bf14975f9a92bde45716bc6bf955f1.jpg";